import { CrossIconBtn } from "assets/SVGs/SVGs";
import React from "react";
import { Modal } from "react-bootstrap";
import "./InformationModal.css";

const InformationModal = ({ show, setShow, infoText }) => {
  const handleClose = () => {
    setShow(false);
  };

  return (
    <Modal
      backdrop="true"
      aria-labelledby="contained-modal-title-vcenter"
      className="info_container"
      show={show}
      onHide={handleClose}
    >
      <Modal.Body className="info_body">
        <p className="info_description_text">{infoText}</p>
        <div className="info_close_icon_container">
          <CrossIconBtn
            className="info_cross_icon"
            onClick={() => setShow(!show)}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default InformationModal;
